module.exports = __webpack_public_path__ + "static/media/smartmockups.094e78ea.jpg";